import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ModalWrapper } from "@msuite/ui/modal";
import { Fragment } from "react";
import { Can } from "@/components/citadel";
import InvoicesFilter from "@/components/invoices";
import { AddProjectInvoiceModal } from "@/modals/projects/add-project-invoice-modal";

/** Props Interface */
interface ProjectInvoiceMenuProps {
	projectId: string;
}

export function ProjectInvoicesMenu({ projectId }: ProjectInvoiceMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addProjectInvoice = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<InvoicesFilter />
			<Can
				action="create"
				subject="Invoice"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={addProjectInvoice.onOpen}
					data-cy="add-project-invoice-button"
				>
					{t("invoices.add_invoice")}
				</Button>
			</Can>
			<ModalWrapper>
				{addProjectInvoice.isOpen && (
					<AddProjectInvoiceModal
						isOpen={addProjectInvoice.isOpen}
						onClose={addProjectInvoice.onClose}
						projectId={projectId}
					/>
				)}
			</ModalWrapper>
		</Fragment>
	);
}
